import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'token-bnp-oidc-helper-token',
  template: `
    <p>
      bnp-oidc-helper-token works 0.0.3!
    </p>
  `,
  styles: []
})
export class BnpOidcHelperTokenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
